<section class="grid partner-info-bar">
	<section class="d-flex flex-wrap justify-content-around align-items-center">
		<div class="text-16-bold">Partner Debug Mode</div>
		<div class="d-flex flex-wrap justify-content-around align-items-center">
			<div class="text-12-bold">Current Partner: &nbsp;</div>
			<input-box color="whitesmoke" [inputPlaceholder]="currentPartner" (inputChange)="editPartner($event)"> </input-box>
		</div>
		<div>
			<icon type="toggle-off" *ngIf="!usingMockAPI"></icon>
			<icon type="toggle-on" *ngIf="usingMockAPI"></icon>
			<button dz-button (click)="toggleMockAPIs()">
				<span>{{ usingMockAPI ? 'Unmock APIs' : 'Mock APIs' }}</span>
			</button>
			<button dz-button (click)="setPartner()" [disabled]="!newPartner">Set Partner</button>
			<button dz-button (click)="resetPartner()" [disabled]="!currentPartner">Reset Partner</button>
		</div>
	</section>
</section>
